module.exports = __webpack_public_path__ + "static/new-logo-e9a878f54744409f3b9f011bc1558d5c.png";